import React from 'react'
import Banner from '../component/Fashion/Banner'
import TodayDeal from '../component/Fashion/TodayDeal'
import Footer from '../component/Common/Footer'
import Header from '../component/Common/Header'
import Brands from '../component/Common/Brands'
import Sports from '../component/Common/Sports'


const Fashion = () => {
    return (
        <>
            <Header />
            <Banner />
            <TodayDeal />
            <Sports />
            <Brands />
            {/* <SprotsGallery /> */}
            <Footer />
        </>
    )
}

export default Fashion